<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 755 755.1" class="text-[#DA291C]">
        <path d="M443.9,612.8v-157H310.7v157H208.9l123.4,123.7c24.8,24.8,65,24.8,89.9,0l123.7-123.7L443.9,612.8L443.9,612.8z   M142.3,546.2V208.9L18.6,332.4c-24.8,24.8-24.8,65,0,89.9L142.3,546.2z M310.7,142.1v157h133.2v-157h102L422.2,18.6  c-24.8-24.8-65-24.8-89.9,0L208.9,142.1H310.7z M736,332.4L612.5,208.9v337l123.7-123.7c24.8-24.6,25.1-64.8,0.8-89.6  c0,0,0,0-0.3-0.3c0,0,0,0-0.5,0H736z" fill="currentColor"/>
</svg>
</template>
